module.exports = __webpack_public_path__ + "static/media/Bologna.84160cdb.png";